import { decodeHexResponse } from '../_common/common.utils';
import OrganisationTypes from './organisation.types';

const INITIAL_STATE = {
	createOrganisationResponse: null,
	updateOrganisationResponse: null,
	getOrganisationResponse: null,
	getAllOrganisationsResponse: null,
	updateOrganisationStatusResponse: null,
};

const organisationReducer = (state = INITIAL_STATE, action: { type: string; payload?: any }) => {
	if (process.env.NODE_ENV === 'development') console.log('Organisation reducer called with action:', action.type, action.payload);

	switch (action.type) {
		// Create Organisation
		case OrganisationTypes.CREATE_ORGANISATION_START:
			return { ...state, createOrganisationResponse: null };
		case OrganisationTypes.CREATE_ORGANISATION_SUCCESS:
			return {
				...state,
				createOrganisationResponse: decodeHexResponse(
					action.payload,
					'createOrganisationKey',
				),
			};
		case OrganisationTypes.CREATE_ORGANISATION_FAILURE:
			return {
				...state,
				createOrganisationResponse: decodeHexResponse(
					action.payload,
					'createOrganisationKey',
				),
			};

		// Update Organisation
		case OrganisationTypes.UPDATE_ORGANISATION_START:
			return { ...state, updateOrganisationResponse: null };
		case OrganisationTypes.UPDATE_ORGANISATION_SUCCESS:
			return {
				...state,
				updateOrganisationResponse: decodeHexResponse(
					action.payload,
					'updateOrganisationKey',
				),
			};
		case OrganisationTypes.UPDATE_ORGANISATION_FAILURE:
			return {
				...state,
				updateOrganisationResponse: decodeHexResponse(
					action.payload,
					'updateOrganisationKey',
				),
			};

		// Get Organisation
		case OrganisationTypes.GET_ORGANISATION_START:
			return { ...state, getOrganisationResponse: null };
		case OrganisationTypes.GET_ORGANISATION_SUCCESS:
			return {
				...state,
				getOrganisationResponse: decodeHexResponse(action.payload, 'getOrganisationKey'),
			};
		case OrganisationTypes.GET_ORGANISATION_FAILURE:
			return {
				...state,
				getOrganisationResponse: decodeHexResponse(action.payload, 'getOrganisationKey'),
			};

		// Get All Organisations
		case OrganisationTypes.GET_ALL_ORGANISATIONS_START:
			if (process.env.NODE_ENV === 'development') console.log('GET_ALL_ORGANISATIONS_START - keeping existing data');
			return { ...state };
		case OrganisationTypes.GET_ALL_ORGANISATIONS_SUCCESS:
			return {
				...state,
				getAllOrganisationsResponse: decodeHexResponse(
					action.payload,
					'getAllOrganisationsKey',
				),
			};
		case OrganisationTypes.GET_ALL_ORGANISATIONS_FAILURE:
			if (process.env.NODE_ENV === 'development') console.log('GET_ALL_ORGANISATIONS_FAILURE - setting response to:', action.payload);
			return {
				...state,
				getAllOrganisationsResponse: decodeHexResponse(
					action.payload,
					'getAllOrganisationsKey',
				),
			};

		// Update Organisation Status
		case OrganisationTypes.UPDATE_ORGANISATION_STATUS_START:
			return { ...state, updateOrganisationStatusResponse: null };
		case OrganisationTypes.UPDATE_ORGANISATION_STATUS_SUCCESS:
			return {
				...state,
				updateOrganisationStatusResponse: decodeHexResponse(
					action.payload,
					'updateOrganisationStatusKey',
				),
			};
		case OrganisationTypes.UPDATE_ORGANISATION_STATUS_FAILURE:
			return {
				...state,
				updateOrganisationStatusResponse: decodeHexResponse(
					action.payload,
					'updateOrganisationStatusKey',
				),
			};

		// Response Management
		case OrganisationTypes.ORGANISATION_RESPONSE_CHANGED:
			return {
				...state,
				createOrganisationResponse: null,
				updateOrganisationResponse: null,
				getOrganisationResponse: null,
				updateOrganisationStatusResponse: null,
			};
		case OrganisationTypes.ORGANISATION_RESPONSE_REST_START:
			return {
				...state,
				createOrganisationResponse: null,
				updateOrganisationResponse: null,
				getOrganisationResponse: null,
				updateOrganisationStatusResponse: null,
			};
		default:
			return state;
	}
};

export default organisationReducer;
